var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m89.414 27.711-39-17.621c-0.26172-0.11719-0.5625-0.11719-0.82422 0l-39 17.621c-0.35938 0.16016-0.58984 0.51562-0.58984 0.91016v10.051c0 0.33594 0.17188 0.65234 0.45312 0.83594 0.28125 0.18359 0.64062 0.21094 0.94922 0.078126l5.4727-2.4258 0.003906 51.84c0 0.55469 0.44531 1 1 1h64.242c0.55469 0 1-0.44531 1-1v-51.844l5.4727 2.4258c0.13281 0.058594 0.26953 0.089844 0.40625 0.089844 0.19141 0 0.38281-0.054687 0.54688-0.16406 0.28125-0.18359 0.45312-0.5 0.45312-0.83594v-10.051c0-0.39453-0.23047-0.75-0.58594-0.91016zm-70.535 8.5586 7.5391-3.3438v55.074h-7.5391zm42.508 51.73h-22.773v-43.977h22.773zm1-45.977h-24.773c-0.55469 0-1 0.44531-1 1v44.977h-8.1953v-55.957l21.582-9.5703 21.688 9.6172v55.91h-8.3008v-44.977c0-0.55078-0.44922-1-1-1zm18.734 45.977h-7.4336v-55.023l7.4336 3.2969zm6.8789-50.867-37.594-16.668c-0.12891-0.058594-0.26953-0.085938-0.40625-0.085938s-0.27734 0.027344-0.40625 0.085938l-37.594 16.668v-7.8672l38-17.168 38 17.168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.379 67.801c0.55469 0 1-0.44531 1-1v-3.4922c0-0.55469-0.44531-1-1-1-0.55469 0-1 0.44531-1 1v3.4922c0 0.55469 0.44922 1 1 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShed);
export default __webpack_public_path__ + "static/media/shed.e9ee4d23.svg";
export { ForwardRef as ReactComponent };